import React from 'react'
import { motion } from 'framer-motion'
import LogoSvg from './LogoSvg';
import { useState, useEffect } from 'react';
import { imagesPaths } from './Images'
import './HomePage.css'

const HomePage = () => {
    const [imgIndex, setImgIndex] = useState(0);

    const handleNextClick = () => {
        setImgIndex((prev) => (prev + 1) % imagesPaths.length)
    }

    useEffect(() => {
        const interval = setInterval(handleNextClick, 8000)
        return () => clearInterval(interval)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className='hero-section' id='home'>
            {/* Background image carousel */}
            <div className='hero-images'>
                <motion.div
                    className='hero-images-track'
                    animate={{ x: `-${100 * imgIndex}vw` }}
                    transition={{ duration: 1.3, type: 'spring', bounce: 0.16 }}
                >
                    {imagesPaths.map((path, index) => (
                        <img
                            key={index}
                            src={`${process.env.PUBLIC_URL}${path}`}
                            alt='background'
                            className='hero-bg-image'
                        />
                    ))}
                </motion.div>
            </div>

            {/* Dark overlay */}
            <div className='hero-overlay' />

            {/* Content */}
            <div className='hero-content'>
                <div className='hero-content-inner'>
                    <div className='hero-left'>
                        <LogoSvg />
                    </div>
                    <div className='hero-right'>
                        <motion.p
                            className='homepage-tagline'
                            initial={{ opacity: 0, y: 8 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1.2, delay: 0.6, ease: 'easeOut' }}
                        >
                            Architecture &amp; Interior Design
                        </motion.p>
                        <motion.p
                            className='homepage-philosophy'
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1.2, delay: 1.0, ease: 'easeOut' }}
                        >
                            We design spaces that go beyond aesthetics — creating places people don't just see, but truly feel.
                        </motion.p>
                    </div>
                </div>
            </div>

            {/* Scroll arrow */}
            <motion.button
                className='hero-scroll-arrow'
                onClick={() => {
                    const hero = document.getElementById('home');
                    if (hero) {
                        window.scrollTo({ top: hero.offsetHeight, behavior: 'smooth' });
                    }
                }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1, delay: 1.2 }}
                aria-label='Scroll down'
            >
                <svg width='16' height='28' viewBox='0 0 16 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <line x1='8' y1='0' x2='8' y2='20' stroke='#C4A882' strokeWidth='1.5' strokeLinecap='round' />
                    <path d='M2 14L8 22L14 14' stroke='#C4A882' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
                </svg>
            </motion.button>
        </div>
    )
}

export default HomePage
